<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            {{ orgLevelLabel }}
        </template>

        <template v-slot:header>
            <div class="nav-tabs-container">
                <div class="nav-tabs-scroll-helper">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: activeTab == 'main'}" href="#tabOrgContentMain" id="tabOrgLinkMain" data-toggle="tab" role="tab" aria-controls="tabOrgContentMain" :aria-selected="activeTab == 'main'">Main</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <slot>
            <div class="tab-content">
                <div class="tab-pane" :class="{'show active': activeTab == 'main'}" id="tabOrgContentMain" role="tabpanel" aria-labelledby="tabOrgLinkMain">
                    <info-widget :collapsible="false">
                        <template v-slot:title>Organizational Level Information</template>

                        <template v-slot:headerbutton>
                            <button type="button" class="btn btn-outline-primary" @click.prevent="editOrgLevel">
                                <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                                Edit
                            </button>
                        </template>

                        <slot>
                            <div class="p-1">
                                <table class="table css-table widget-table table-fixed">
                                    <thead>
                                        <tr>
                                            <th v-if="showLocations" class="cw-toggle"></th>
                                            <th>Option Value</th>
                                            <th v-if="showLocations" class="cw-date text-right">Locations</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="opt in orgLevelOptions">
                                        <tr>
                                            <td v-if="showLocations" class="cw-toggle position-relative">
                                                <a href class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': showLocationsForOption[opt.id]}" @click.prevent="toggleLocationsForOption(opt.id)">
                                                    <collapse-toggle-button />
                                                </a>
                                            </td>
                                            <td class="truncate-wrapper">
                                                <span>{{ opt.org_level_description }}</span>
                                            </td>
                                            <td v-if="showLocations" class="text-right">
                                                <span>{{ opt.work_locations.length }}</span>
                                            </td>
                                        </tr>
                                        <tr class="child no-transition" v-if="showLocations && showLocationsForOption[opt.id]">
                                            <td colspan="3">
                                                <div class="card card-body item-details">
                                                    <template v-for="wl in opt.work_locations">
                                                        <p class="mb-hf">{{ wl }}</p>
                                                    </template>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </slot>
                    </info-widget>
                </div>
            </div>
        </slot>

        <edit-org-level-modal ref="editOrgLevelModal" :orgs="orgs" :level="level" :client="client" @updated="onUpdate" @close="editOrgLevelModalOpen = false" />
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import InfoWidget from '@/components/InfoWidget'
import ButtonRow from '@/components/ButtonRow'
import EditOrgLevelModal from './EditOrgLevelModal'

export default {
    props: ['client', 'orgs', 'level', 'tab', ],
    components: {Sidebar, InfoWidget, ButtonRow, EditOrgLevelModal},
    computed: {
        orgLevelOptions() {
            return this.orgs.filter(o => o.org_level == this.level)
        },
        orgLevelLabel() {
            return this.client[`org_level_${this.level}_label`]
        },
        showLocations() {
            return this.level < this.client.location_org_level
        }
    },
    data() {
        return {
            activeTab: this.tab || 'main',
            editOrgLevelModalOpen: false,
            showLocationsForOption: {}
        }
    },
    methods: {
        editOrgLevel() {
            this.editOrgLevelModalOpen = true
            this.$refs.editOrgLevelModal.open()
        },
        onUpdate() {
            this.$emit('updated')
        },
        toggleLocationsForOption(optId) {
            this.showLocationsForOption[optId] = !this.showLocationsForOption[optId]
        },
    },
}
</script>

